@import '../../global/css/mixins/responsive';

s-container {
  display: block;
  margin: 0 auto;
  max-width: var(--breakpoint-xl-max);
  padding: 0 var(--padding-xl);
}

// TODO custom props can't be used here (should use --breakpoint-lg-max). Hard-coding value until we decide on a solution
@media only screen and (max-width: $lg-max-size) {
  s-container {
    padding: 0 var(--padding-lg);
  }
}

// TODO custom props can't be used here (should use --breakpoint-md-max). Hard-coding value until we decide on a solution
@media only screen and (max-width: $md-max-size) {
  s-container {
    padding: 0 var(--padding-sm);
  }
}
